/**
 * Компонент AnimatedCard
 * Красивая карточка с hover эффектами в стиле Aura.build и 21st.dev
 * Автор: AI Market Hub
 * 
 * Принцип: Обертка для существующих карточек, не меняет логику
 */

import { motion } from 'framer-motion';
import { useState } from 'react';

export default function AnimatedCard({ 
  children, 
  className = '', 
  onClick,
  hover = true,
  glow = false,
  ...props 
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      whileHover={hover ? { scale: 1.02, y: -4 } : {}}
      whileTap={onClick ? { scale: 0.98 } : {}}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      onClick={onClick}
      className={`
        relative overflow-hidden rounded-2xl
        bg-white/5 backdrop-blur-xl
        border border-white/10
        transition-all duration-300
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
        ${hover ? 'hover:bg-white/10 hover:border-purple-500/50' : ''}
        ${glow ? 'hover:shadow-lg hover:shadow-purple-500/20' : ''}
      `}
      {...props}
    >
      {/* Градиентная граница при hover */}
      {hover && (
        <div 
          className={`
            absolute inset-0 rounded-2xl
            bg-gradient-to-r from-purple-600/0 via-pink-600/0 to-purple-600/0
            transition-opacity duration-500
            ${isHovered ? 'opacity-100 from-purple-600/20 via-pink-600/20 to-purple-600/20' : 'opacity-0'}
            pointer-events-none
          `}
        />
      )}

      {/* Свечение при hover (опционально) */}
      {glow && isHovered && (
        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl blur-xl opacity-30 animate-pulse pointer-events-none" />
      )}

      {/* Контент */}
      <div className="relative z-10">
        {children}
      </div>

      {/* Декоративная линия снизу при hover */}
      {hover && (
        <div 
          className={`
            absolute bottom-0 left-0 right-0 h-0.5
            bg-gradient-to-r from-purple-500 via-pink-500 to-purple-500
            transition-opacity duration-300
            ${isHovered ? 'opacity-100' : 'opacity-0'}
          `}
        />
      )}
    </motion.div>
  );
}

